<template>
<div>
    <hr />
    <h4 class="page-header page-header-blue">Hazards <button type="button" class="btn btn-sm btn-info" v-on:click="addStepHazard(stepId)" title="Add Step Hazard"><i class="fa fa-plus"></i> Hazard</button></h4>
    <div class="row">
        <div class="col-sm-12" v-if="steps[stepId]">
            <div v-for="(hazard, ix) in steps[stepId].hazards">

                <div :id="`step-hazard-${ix}`" class="row step-hazard">
                    <div class="col-md-6">
                        <div class="form-group input-group-sm">
                            <label>Hazards:</label>
                            <select :name="`steps[${stepId}][hazards][${ix}][hazard]`" class="hazard-input form-control" v-model="steps[stepId].hazards[ix].hazard" @change="updateStore">
                                <option v-for="haz in hazardlist" v-bind:value="haz.id">
                                    {{ haz.text }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group input-group-sm">
                            <label>RAC <a href="/Images/RAC-Matrix.PNG" target="_blank" title="View Risk Assessment Code (RAC) Matrix"><i class="fa fa-question-circle"></i></a>:</label>
                            <select :name="`steps[${stepId}][hazards][${ix}][rac_level]`" class="rac-input form-control" placeholder="Select An RAC Level" v-model="steps[stepId].hazards[ix].rac_level">
                                <option v-for="rac in racs" v-bind:value="rac.id">
                                    {{ rac.text }}
                                </option>
                            </select>
                        </div>
                        <button type="button" class="btn btn-xs btn-danger" title="Remove Hazard Step" v-on:click="removeHazard(`${stepId}`, `${ix}`)"><i class="fa fa-remove"></i> Remove Hazard</button>
                    </div>
                    <div class="col-md-6">

                        <jsa-controls-mselect :name="`steps[${stepId}][hazards][${ix}][controls][]`" :step_id="stepId" :hazard_id="ix"></jsa-controls-mselect>

                        <div class="form-group input-group-sm">
                            <label>Other Controls (Optional):</label>
                            <textarea :name="`steps[${stepId}][hazards][${ix}][other_controls]`" class="other-control-input form-control" style="min-height: 75px;" placeholder="Enter Additional Safety Controls" v-model="steps[stepId].hazards[ix].other_controls">
						</textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>


<script>
export default {
    props: ['stepId'],

    data: function() {
        return {
            loading: true,
            // jsa_id: this.$route.params.id,
            jsa: {},
            steps: {},
            mstep_id: this.stepId,
            hazardlist: {},
            selected_hazard: "",
            errors: {},
            racs: [{
                    'id': "Extremely High",
                    'text': "Extremely High"
                },
                {
                    'id': "High",
                    'text': "High"
                },
                {
                    'id': "Medium",
                    'text': "Medium"
                },
                {
                    'id': "Low",
                    'text': "Low"
                }
            ],

        }
    },

    methods: {
        updateStore: function() {
            this.$set(this.jsa, 'jsa_steps', this.steps);
            this.$store.commit('putJsa', this.jsa)
        },

        addStepHazard: function(stepId, hazard) {
            //Variables
            var tmp_hazard_id = (new Date()).getTime();
            var hazardSelected = '';
            var hazardControls = [];
            var racSelected = '';
            var otherControls = '';

            this.hazard_id = tmp_hazard_id;

            this.$set(this.jsa.jsa_steps[stepId].hazards, tmp_hazard_id, {
                'hazard': "",
                'rac_level': "",
                'controls': [], // array
                'other_controls': "" // text
            });
            this.steps = this.jsa.jsa_steps;
            this.$store.commit('putJsa', this.jsa);
        },

        removeHazard: function(step, hazard) {
            var theStepHazards = this.steps[this.mstep_id].hazards;
            this.$delete(theStepHazards, hazard);
            this.jsa.jsa_steps = this.steps;
            this.$store.commit('putJsa', this.jsa);
        },
    },

    mounted() {
        this.jsa = this.$store.state.JsaStoreModule.jsa;
        this.steps = this.jsa.jsa_steps;
        this.hazardlist = this.$store.state.JsaStoreModule.hazardlist;
        // See if there are any hazards already in this job_step
        if (Object.keys(this.jsa.jsa_steps[this.mstep_id].hazards).length === 0) {
            // add a default hazard
            this.addStepHazard(this.mstep_id, {});
        }
    },

}
</script>
